// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static empresas:string="empresas";
    public static departamentos:string="departamentos";
    public static empresaslista:string="empresaslista";
    public static departamentoslista:string="departamentoslista";
    public static cerrar_session:string="cerrar_session";
    public static notificaciones:string="notificaciones";
    public static table:string="table";
    public static tablas:string="tablas";
    public static tablas_test:string="tablas_test";
    public static usuarios:string="usuarios";
    public static usuarioslista:string="usuarioslista";
    public static usuariosformulario:string="usuariosformulario";
    public static mi_perfil:string="mi_perfil";
    public static administracion:string="administracion";
    public static gruposlista:string="gruposlista";
    public static grupos:string="grupos";
    public static gruposformulario:string="gruposformulario";
    public static lostpwd:string="lostpwd";
    public static confirm_new_password:string="confirm_new_password";
    public static instalacion:string="instalacion";
    public static inventario:string="inventario";
    public static inventario_treeview:string="inventario_treeview";
    public static inventario_formulario:string="inventario_formulario";
    public static handlerinventario_formulario:string="handlerinventario_formulario";
    public static rol:string="rol";
    public static rollista:string="rollista";
    public static rolformulario:string="rolformulario";
    public static plataforma:string="plataforma";
    public static instalacion_plataforma:string="instalacion_plataforma";
    public static tablasformulario:string="tablasformulario";
    public static tablaslista:string="tablaslista";
    public static menu_plataforma:string="menu_plataforma";
    public static menu_plataforma_lista:string="menu_plataforma_lista";
    public static menu_plataforma_formulario:string="menu_plataforma_formulario";
    public static empresasformulario:string="empresasformulario";
    public static departamentosformulario:string="departamentosformulario";
    public static ambitos:string="ambitos";
    public static ambitosformulario:string="ambitosformulario";
    public static planes:string="planes";
    public static planesformulario:string="planesformulario";
    public static contadoresformulario:string="contadoresformulario";
    public static contadores:string="contadores";
    public static subambitos:string="subambitos";
    public static subambitosformulario:string="subambitosformulario";
    public static enumeraciones:string="enumeraciones";
    public static enumeracion:string="enumeracion";
    public static objetivos:string="objetivos";
    public static objetivosformulario:string="objetivosformulario";
    public static actuaciones:string="actuaciones";
    public static actuacionesFormulario:string="actuacionesFormulario";
    public static tareas:string="tareas";
    public static tareasFormulario:string="TareasFormulario";
    public static viewKanban:string="viewKanban";
    public static kanban:string="kanban";
    public static tbkn:string="tbkn";
    public static viewtbkn:string="viewtbkn";
    public static tickets:string="tickets";
    public static ticketsFormulario:string="ticketsFormulario";
    public static FullViewKanban:string="FullViewKanban";
    public static ticketsKanban:string="ticketsKanban";
    public static ticketsFormularioUser:string="ticketsFormularioUser";
    public static clientes:string="clientes";
    public static clientesformulario:string="clientesformulario";
    public static informes:string="informes";
    public static actuaciones_informes:string="actuaciones_informes";
    public static repositorio_informes:string="repositorio_informes";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    
}
